import httpService from '@/app/arch/services/HttpService';

export default class UserWalletRequest {
  static baseUrl() {
    return '/wallet/balance';
  }

  static get(ClientId) {
    return httpService.get(this.baseUrl(), {
      params: {
        ClientId,
      },
    });
  }
}
